import { TableTitlesContext } from '../components/table-titles-context'
import { useContext, useEffect, useState } from 'react'
import { getTables } from '../fetch/get-tables'

/** Resolve a saved table name rather than treating assistant-authored link text as metadata. */
export function useTableCardTitle(matterId: string | undefined, tableId: string | undefined) {
  const shared = useContext(TableTitlesContext)
  const load = shared?.load
  const [result, setResult] = useState<{ matterId: string; tableId: string; name: string | null } | null>(null)

  useEffect(() => {
    if (!matterId || !tableId) return
    if (load) {
      load(matterId)
      return
    }
    const controller = new AbortController()
    getTables(matterId, controller.signal)
      .then((tables) => {
        if (!controller.signal.aborted) {
          setResult({ matterId, tableId, name: tables.find((table) => table.id === tableId)?.name ?? null })
        }
      })
      .catch(() => {
        if (!controller.signal.aborted) setResult({ matterId, tableId, name: 'Table' })
      })
    return () => controller.abort()
  }, [matterId, tableId, load])

  if (shared) {
    const tables = matterId ? shared.tablesByMatter[matterId] : undefined
    const name = tables ? tables.find((table) => table.id === tableId)?.name ?? null : 'Table'
    return { title: name ?? 'Table unavailable', unavailable: name === null }
  }
  const name = result && result.matterId === matterId && result.tableId === tableId ? result.name : 'Table'
  return { title: name ?? 'Table unavailable', unavailable: name === null }
}
